<template>

  <v-dialog
    v-model="show"
    persistent
    max-width="420">
    <v-card>
        <v-toolbar dense dark color="secondary">New Account Receivables<v-spacer/><v-icon @click="emitToParent('cancel')">mdi-close</v-icon> </v-toolbar>
        <v-card-text>
             <v-form
                ref="form"
                class="mt-3"
                v-model="valid"
                lazy-validation
              >
               <v-text-field
                v-model="invoice"
                label="Enter Invoice #"
                :rules="textRules"
                append-outer-icon="mdi-send"
                dense
                outlined
                @click:append-outer="getSalesByInvoice()"
                required
                ></v-text-field>
                  <template v-if="sales.id!=0 && sales.id!=undefined">
                      <p>Trade Name: {{sales.trade_name}}</p>
                      <p>Grand Total: {{$money(sales.amount)}}</p>
                      <p>Delivered Date: {{sales.delivered_date | moment($date_only) }}</p>
                  </template>
             </v-form>
             <v-divider/>
        </v-card-text>
        <v-card-actions>
                <v-btn color="warning" small  text @click="emitToParent('cancel')">CLOSE</v-btn>
            <v-spacer></v-spacer>
             <template v-if="sales.id!=0 && sales.id!=undefined">
              <v-btn  small color="success" @click="validate()">ADD</v-btn>
             </template>
        </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  mapMutations
} from 'vuex'
export default {
  props: {
    show: {
        type: Boolean,
        default: false
    }
  },
  data: () => ({
    valid:true,
    invoice:'',
      textRules: [
        v => !!v || 'Field is required'
      ],
      sales:{}
  }),
  computed: {
  },
  methods: {
     ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText', 'setKilosToDistribute']),
    emitToParent (action) {
       this.$emit('DialogEvent', action)
    },
    getSalesByInvoice(){
      console.log("getSalesByInvoice")
        this.$http.post("sales/preview", {invoice:this.invoice}).then(response => {
              response.data.sales != null ? this.sales = response.data.sales:this.sales={}
          }).catch(e => {
            console.log(e.data)
        })
    },
    validate () {
        if (this.$refs.form.validate()) {
          this.Update()
        }
    },
    Update() {
      this.$http.post("sales/add_to_receivable", this.sales).then(response => {
            this.GET_RESPONSE(response)
            this.$emit('DialogEvent', "close")
          }).catch(e => {
            console.log(e.data)
        })
    }
  }
}
</script>
